module.exports = __webpack_public_path__ + "static/img/logoText.73310867.png";